import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import Resource from "./Resource";

const Resources = ({
  sections,
  onOpenAddItemsModal,
  onItemClick,
  onDeleteItem,
  onDeleteSection,
  onEditItem,
  onMoveItem,
  onEditSection,
  onMoveSection,
  sectionRefs,
  scrollToSectionByHash
}) => {
  useEffect(() => {
    scrollToSectionByHash();
  }, []);

  const droppedOnSamePosition = ({ destination, source }) =>
    destination.droppableId === source.droppableId &&
    destination.index === source.index;

  const onDragEnd = result => {
    if (!result.destination || droppedOnSamePosition(result)) {
      return;
    }

    const prevItemIndex = () => {
      return result.destination.index < result.source.index
        ? result.destination.index - 1
        : result.destination.index;
    };

    let placeAfterId = 0;
    if (result.type === "SECTIONS") {
      if (result.destination.index > 0) {
        placeAfterId = sections[prevItemIndex()].id;
      }
      onMoveSection(
        result.draggableId,
        placeAfterId,
        result.source.index,
        result.destination.index
      );
    } else {
      const oldSectionId = parseInt(result.source.droppableId);
      const newSectionId = parseInt(result.destination.droppableId);
      if (result.destination.index > 0) {
        const newSection = sections.find(x => x.id === newSectionId);
        if (oldSectionId === newSectionId) {
          placeAfterId = newSection.items[prevItemIndex()].id;
        } else {
          placeAfterId = newSection.items[result.destination.index - 1].id;
        }
      }
      onMoveItem(
        result.draggableId,
        oldSectionId,
        newSectionId,
        placeAfterId,
        result.source.index,
        result.destination.index
      );
    }
  };
  const sectionContent = (section, i, dragHandleProps) => {
    return (
      <Resource
        key={i}
        section={section}
        onAddItems={() => onOpenAddItemsModal(section)}
        onItemClick={onItemClick}
        onDeleteItem={onDeleteItem}
        onDeleteSection={onDeleteSection}
        onEditItem={onEditItem}
        onEditSection={onEditSection}
        dragHandleProps={dragHandleProps}
      />
    );
  };
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="resource" type="SECTIONS">
        {(provided, snapshot) => (
          <div ref={provided.innerRef}>
            {sections.map((section, i) => (
              <div
                ref={sectionRefs[section.id]}
                key={`section-container-${section.id}`}
              >
                <Draggable
                  key={section.id}
                  draggableId={`${section.id}`}
                  index={i}
                >
                  {(provided, snapshot) => (
                    <div ref={provided.innerRef} {...provided.draggableProps}>
                      {sectionContent(section, i, provided.dragHandleProps)}
                    </div>
                  )}
                </Draggable>
              </div>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default Resources;

Resources.propTypes = {
  onDeleteItem: PropTypes.func,
  onDeleteSection: PropTypes.func,
  onEditItem: PropTypes.func,
  onMoveItem: PropTypes.func,
  onEditSection: PropTypes.func,
  onMoveSection: PropTypes.func,
  onItemClick: PropTypes.func,
  onOpenAddItemsModal: PropTypes.func,
  sectionRefs: PropTypes.array,
  scrollToSectionByHash: PropTypes.func,
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * The name of the resource section
       */
      name: PropTypes.string,
      /**
       * The resources within the resource section
       */
      items: PropTypes.arrayOf(
        PropTypes.shape({
          /**
           * The name of the resource
           */
          name: PropTypes.string,

          /**
           * The type of the resource
           */
          type: PropTypes.string
        })
      )
    })
  )
};
